// src/services/geoBannerGate.js
//
// Gate de frequência do aviso de localização (v3.7.3 — Bloco C).
//
// Regra de produto: o aviso "Localização parcial/desativada" aparece NO
// MÁXIMO uma vez a cada COOLDOWN_DIAS e SOMENTE em contexto relevante (ao
// abrir o registro de treino, que se beneficia da validação automática) —
// nunca no cold start de toda sessão. "Ignorar" persiste aqui; a exibição em
// si também marca o cooldown (mostrar já conta).

const SHOWN_AT_KEY = "lesvita_geo_banner_shown_at";
const COOLDOWN_DIAS = 14;

export function canShowGeoBanner() {
  try {
    const at = Number(localStorage.getItem(SHOWN_AT_KEY) || 0);
    return Date.now() - at > COOLDOWN_DIAS * 24 * 60 * 60 * 1000;
  } catch {
    return false;
  }
}

export function markGeoBannerShown() {
  try {
    localStorage.setItem(SHOWN_AT_KEY, String(Date.now()));
  } catch {
    /* storage indisponível: melhor não mostrar de novo do que spammar */
  }
}

const geoBannerGate = {canShowGeoBanner, markGeoBannerShown};
export default geoBannerGate;
